var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.texts),function(entry){return _c('div',{key:entry.text,attrs:{"id":"main-content"}},[(entry.text.length < 700)?_c('TextContainer',{attrs:{"src":entry.imgPath,"id":entry.id,"content":entry.text,"orientation":entry.orientation,"title":entry.title}}):_c('BigTextContainer',{attrs:{"src":entry.imgPath,"id":entry.id,"content":entry.text,"orientation":entry.orientation,"title":entry.title}})],1)}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6427b4ac","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Projects.vue
// module id = null
// module chunks = 